import { SimpleGrid, Box, } from "@chakra-ui/react"
import { descriptionData } from "../data/description"
import { Icon } from '@chakra-ui/react'
import { SiMinds } from 'react-icons/si'
import { FiTarget } from 'react-icons/fi'
import { IoIosGitNetwork } from 'react-icons/io'
import { RiOpenArmLine } from 'react-icons/ri'

const DescriptionComp = () => {

    return (
        <Box>
            <SimpleGrid columns={[1, null, 2, 3]} spacing='40px' textColor='white'>
                {
                    descriptionData.map((data, index) => {
                        return (
                            <Box maxW='sm' borderRadius='lg' overflow='hidden' key={index} shadow='lg' bgColor={data.bg} opacity='0.8'>

                                <Box bgColor='blackAlpha.100' pt={1} pb={4} position='relative'>
                                    <Box position='absolute' bgColor='white' px={2} py={2} rounded='full' w={10} h={10}
                                        bottom='-12' left='0' right='0' top='0' margin='auto' shadow='lg'
                                    >
                                        <Icon as={data.title === 'IDEA' ? SiMinds : data.title === 'OBIETTIVI' ? FiTarget : data.title === 'ATTIVITà PRINCIPALI'.toUpperCase() ? IoIosGitNetwork : RiOpenArmLine} w={6} h={6} color='green.500' />
                                    </Box>
                                    <Box
                                        fontWeight='semibold'
                                        as='h4'
                                        lineHeight='tight'
                                        noOfLines={1}
                                        ml={2}
                                        mt={2}
                                    >
                                        {data.title}
                                    </Box>
                                </Box>



                                <Box p='6'>
                                    <Box
                                        mt='1'
                                        fontWeight='normal'
                                        as='h4'
                                        textAlign='justify'
                                        dangerouslySetInnerHTML={{ __html: data.body }}
                                    >

                                    </Box>

                                </Box>
                            </Box>

                        )
                    })
                }
            </SimpleGrid>
        </Box>
    )
}

export default DescriptionComp